import { ref, onMounted, onUnmounted } from 'vue';
import { accountsService } from '@/service/nexus';

/**
 * Composable for managing and periodically checking admin status
 * @param {number} intervalMs - Interval in milliseconds for checking admin status (default: 5 minutes)
 * @returns {Object} Object containing isAdmin ref and checkAdminStatus function
 */
export function useAdminStatus(intervalMs = 300000) {
    // 5 minutes default
    const isAdmin = ref(localStorage.getItem('isAccountAdmin') === 'true');
    let intervalId = null;

    /**
     * Check current admin status from the backend
     */
    const checkAdminStatus = async () => {
        try {
            const response = await accountsService.getCurrentAccount();
            if (response.data) {
                const adminStatus = response.data.is_account_admin || false;

                // Update localStorage
                localStorage.setItem('isAccountAdmin', adminStatus ? 'true' : 'false');
                localStorage.setItem('currentAccount', JSON.stringify(response.data));

                // Update reactive ref
                isAdmin.value = adminStatus;
            }
        } catch (error) {
            console.error('Failed to check admin status:', error);
            // Don't clear admin status on network errors to avoid flickering
        }
    };

    onMounted(() => {
        // Check immediately on mount
        checkAdminStatus();

        // Set up periodic check
        if (intervalMs > 0) {
            intervalId = setInterval(checkAdminStatus, intervalMs);
        }
    });

    onUnmounted(() => {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    });

    return {
        isAdmin,
        checkAdminStatus
    };
}
